/* TRW CUSTOM JAVASCRIPT
/*************************/
$(() => {

  //init trial pdp results carousel
  if(!!$('.trial-results-carousel').length){
    $('.trial-results-carousel').slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      draggable: true,
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev">⭠</div>',
      nextArrow: '<div class="slick-arrow slick-next">⭢</div>'
    });
  }

  //init trial pdp ingredients carousel
  if(!!$('.trial-ingredients-carousel').length){
    /* Slick needs to get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
      const $carousel = $('.trial-ingredients-carousel');
      /* Initializes a slick carousel only on mobile screens */
      if ($(window).width() > 900) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      }
      else{
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            draggable: true,
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev">⭠</div>',
            nextArrow: '<div class="slick-arrow slick-next">⭢</div>',
          });                
        }
      }
    });
  }

  $(".add-to-cart--trial").click(function() {
    $(this).prop("disabled",true);
    $(this).html("Item In Cart");
  });

});
